import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/the-definitive-guide-for-nearshore-outsourcing-software-services-in-africa",
)({
  beforeLoad: () => {
    throw redirect({ to: "/blog/nearshore-outsourcing-guide", replace: true });
  },
});
